import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getPayments = async () => {
  // Retrieve token from local storage
  const userinfo = localStorage.getItem("user");
  const userData = JSON.parse(userinfo);
  const token = userData.token;

  // const token = userinfo.token;

  // Check if token exists
  if (!token) {
    throw new Error("Token not found in local storage");
  }

  const response = await axios.get(`${base_url}payment/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

const createPayments = async (paydata) => {
  const response = await axios.post(`${base_url}payment/`, paydata, config);

  return response.data;
};

const updatePayments = async (payment) => {
  const response = await axios.put(
    `${base_url}payment/${payment.id}`,
    payment,
    config
  );

  return response.data;
};

const getBrand = async (id) => {
  const response = await axios.get(`${base_url}programs/${id}`, config);

  return response.data;
};

const deletePayments = async (id) => {
  const response = await axios.delete(`${base_url}programs/${id}`, config);

  return response.data;
};

//new end point

const getPaymentOverview = async () => {
  const response = await axios.get(
    `${base_url}payment/pending/paymentall`,
    config
  );
  return response.data;
};

const getPaymentSuccess = async () => {
  const response = await axios.get(
    `${base_url}payment/success/paymentall`,
    config
  );
  return response.data;
};

const getPaymentReceipt = async () => {
  const response = await axios.get(
    `${base_url}payment/receipt-payament`,
    config
  );
  return response.data;
};

const getViewInvoice = async (queryParams) => {
  // const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}user/viewInvoice?${queryParams}`,
    config
  );
  return response.data;
};

const getInvoiceData = async (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${base_url}invoince/getInvoiceData?${queryParams}`,
    config
  );
  return response.data;
};

const getInvoiceReceiptPayment = async () => {
  const response = await axios.get(
    `${base_url}paymentvsrecipts/receipt-payament`,
    config
  );
  return response.data;
};

const getInvoiceReceiptInfo = async () => {
  const response = await axios.get(
    `${base_url}paymentvsrecipts/receipt-payament-invoince-info`,
    config
  );
  return response.data;
};
const csvDownloads = async () => {
  const response = await axios.get(
    `${base_url}invoince/download-template`,
    config
  );
  return response.data;
};
const uploadCsvs = async (params) => {
  const response = await axios.post(
    `${base_url}invoince/uploadInvoiceViaFile`,
    params,
    config
  );
  return response.data;
};

const paymentService = {
  getPayments,
  createPayments,
  getBrand,
  updatePayments,
  deletePayments,
  uploadCsvs,
  getPaymentOverview,
  csvDownloads,
  getPaymentSuccess,
  getPaymentReceipt,
  getViewInvoice,
  getInvoiceData,
  getInvoiceReceiptPayment,
  getInvoiceReceiptInfo,
};

export default paymentService;
